/**
 * The reducer key used by core data in store registration.
 * This is defined in a separate file to avoid cycle-dependency
 *
 * @type {string}
 */
export var REDUCER_KEY = 'core';
//# sourceMappingURL=name.js.map